import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerAllInstagramStoryPosts.graphql';
import { Query, QueryinfluencerAllInstagramStoryPostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerAllInstagramStoryPostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerAllInstagramStoryPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerAllInstagramStoryPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerAllInstagramStoryPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerAllInstagramStoryPostsArgs>
): QueryResult<Query, QueryinfluencerAllInstagramStoryPostsArgs> & {
  getInfluencerAllInstagramStoryPosts: LazyQueryExecFunction<Query, QueryinfluencerAllInstagramStoryPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerAllInstagramStoryPosts, result] = useLazyQuery<Query, QueryinfluencerAllInstagramStoryPostsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerAllInstagramStoryPosts, ...result };
};

export const useInfluencerAllInstagramStoryPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerAllInstagramStoryPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerAllInstagramStoryPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerAllInstagramStoryPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerAllInstagramStoryPosts };
};
// Suspense Query Hooks
export const useInfluencerAllInstagramStoryPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerAllInstagramStoryPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerAllInstagramStoryPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
